import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics/events";
import { type LocationState } from "history";
import pluralize from "pluralize";

import { Button } from "../../components/Button";
import {
  getWorkplacePlacementsPath,
  type WorkplacePlacementsPathSource,
} from "../../Placements/paths";

interface ViewStaffJobsButtonProps {
  workplaceId: string;
  source: WorkplacePlacementsPathSource;
  placementsCount: number;
  placementCandidateId: string | undefined;
  locationState: LocationState;
}

export function ViewStaffJobsButton(props: ViewStaffJobsButtonProps) {
  const { workplaceId, source, placementsCount, placementCandidateId, locationState } = props;

  return (
    <Button
      fullWidth
      variant="outlined"
      href={getWorkplacePlacementsPath(workplaceId, source)}
      locationState={locationState}
      onClick={() => {
        logEvent(APP_V2_APP_EVENTS.PLACEMENT_WORKPLACE_AD_CARD_CLICKED, {
          workplaceId,
          placementCandidateId,
          openJobsCount: placementsCount,
        });
      }}
    >
      View {placementsCount} staff {pluralize("job", placementsCount)}
    </Button>
  );
}
